export const ISLIVE = true;
export const SUCCESS_CODE = "000"